import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonBackButton,
  IonTitle,
  IonContent,
  IonItem,
  IonLabel,
  useIonViewWillEnter,
} from '@ionic/react';
import SectionCard from '@/components/SectionCard';
import SnowballMenu from '@/modules/user/SnowballMenu';
import EngagementMetrics from './EngagementMetrics';
import { pxToRem } from '@/modules/config/constants';

const EngagementMetricsPage: React.FC = () => {
  const { topicId } = useParams<{ topicId: string }>();
  const [topicTitle, setTopicTitle] = useState<string | undefined>(undefined);

  useIonViewWillEnter(() => {
    setTopicTitle(
      new URLSearchParams(window.location.search).get('n') || undefined
    );
  });

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/topics" />
          </IonButtons>
          <IonTitle>Engagement</IonTitle>
          <IonButtons slot="end">
            <SnowballMenu />
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        {topicTitle && (
          <h1
            style={{
              fontSize: pxToRem(24),
              fontWeight: 600,
              margin: '16px 16px 0',
              wordBreak: 'break-word',
            }}
          >
            {topicTitle}
          </h1>
        )}
        <SectionCard>
          <IonItem lines="none">
            <IonLabel>
              <EngagementMetrics topicId={topicId} />
            </IonLabel>
          </IonItem>
        </SectionCard>
      </IonContent>
    </IonPage>
  );
};

export default EngagementMetricsPage;
